import { render } from "./list-table.vue?vue&type=template&id=10b4428a&ts=true"
import script from "./list-table.vue?vue&type=script&lang=ts"
export * from "./list-table.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__